export default __webpack_public_path__ + "static/media/gb.3237be21.svg";